// Notícias que a página já mostra no Hero (29/10/2026). Na capa, o Hero leva a
// manchete e a grade de últimas notícias vem logo abaixo: sem isto a mesma
// notícia aparecia duas vezes. Devolve o caminho de cada slide (sem domínio,
// barra final, busca ou âncora) para a grade automática deixar de fora.
// O Hero antigo, de um slide só, guarda o link no próprio bloco.
const limpar = (url, flatten) =>
  flatten(url).split(/[?#]/)[0].replace(/\/+$/, '');

export const caminhosNoHero = (blocks, flatten) =>
  Object.values(blocks || {})
    .filter((b) => b?.['@type'] === 'agsusHero')
    .flatMap((b) =>
      Array.isArray(b.slides) && b.slides.length ? b.slides : [b],
    )
    .map((s) => s?.url || s?.primaryCtaUrl)
    .filter(Boolean)
    .map((u) => limpar(u, flatten))
    .filter(Boolean);
